// extracted by mini-css-extract-plugin
module.exports = {"Footer":"TableFooter_Footer__DT00O"};